export var source = "query UserMePaymentQuery {\n  user {\n    me {\n      paymentOption\n      payment {\n        id\n        email\n        cardNumber\n        expiryDate\n      }\n    }\n  }\n}";
export default source;